import { HStack, Link, Text, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const CardContainer = HStack.withConfig({
  backgroundColor: theme.token('background-pattern'),
  borderRadius: 'lg',
  paddingY: '$4',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
});

export const ItemName = Text.withConfig({
  fontFamily: 'heading',
  fontSize: {
    base: 'xs',
    md: 'md',
  },
  lineHeight: '2xs',
  marginTop: '$1',
  height: {
    base: 'auto',
    md: '$8',
  },
  width: {
    base: 'full',
    md: '1/2',
  },
});

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: Styles.color.tertiary,
      },
    },
  },
});

export const ActionWrapper = VStack.withConfig({
  alignSelf: { base: 'flex-end' },
  marginLeft: '$4',
});

export const Details = VStack.withConfig({
  flex: 1,
  marginLeft: '$4',
});
